import moment from "moment";
import data from '../data/basic.json';

import "moment/min/locales";
moment.locale('ru'); 

const initState = {
    page: 'home',
    region: 23,
    selectedDate: moment().locale('ru'),
    data: data,
    updateURL: 'https://golubi.verych.ru/api/feed.php',
    chanelURL: 'https://www.youtube.com/c/ГолубиЛенинградская/videos',
    email: 'golubi@verych.ru',
    updated: false,
    updatedDate: null
}

export default (state = initState, action) => {
    if(action['type'] == 'showHome') {
        const newState = Object.assign({}, state);
        newState.page = 'home';
        return newState;
    }      
    if(action['type'] == 'region') {
        const newState = {...state};
        newState.region = action.payload.code;
        return newState;
    }   
    if(action['type'] == 'date') {
        const newState = Object.assign({}, state);
        newState.selectedDate = action.payload;
        return newState;
    }   
    if(action['type'] == 'update') {
        const newState = Object.assign({}, state);
        newState.data = action.payload;
        newState.updated = true;
        newState.updatedDate = moment();
        return newState;
    }   
    return state;
}